export const text = {
  title: "Contact Us",
  description: "Description",
  descriptionPlaceholder: "Enter Description",
  help: "What Can We Help You With ?",
  queries: "Have any queries in mind? Get in Touch",
  pendingQueries: "Pending Queries",
  repliedQueries: "Replied Queries ",
};
